import { Injectable } from '@angular/core';
import { CountryInterface } from '@app/core/interfaces';
import * as countryActions from '@app/store/my-zone/country/country.actions';
import { CountryService } from '@app/store/my-zone/country/country.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

/**
 * @deprecated use OutCountriesModule from outshared-lib
 */
@Injectable()
export class CountryEffects {
    getCountries$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(countryActions.LOAD_COUNTRIES),
            switchMap(() =>
                this.countryService.getCountries().pipe(
                    map((countries: CountryInterface[]) => new countryActions.LoadCountriesSuccess({ countries })),
                    catchError((errors) => of(new countryActions.LoadCountriesError({ errors })))
                )
            )
        )
    );

    constructor(private actions$: Actions, private countryService: CountryService) {}
}
